import type { BelugaPatientPreferenceMedicationValue } from "./types";

export const EMPTY_BELUGA_MEDICATION: BelugaPatientPreferenceMedicationValue = {
  name: "",
  strength: "",
  dispenseUnit: "",
  quantity: "",
  refills: "",
  daysSupply: "",
  sig: "",
  medId: "",
};
